<kendo-drawer-container>
    <kendo-drawer
        #drawer
        mode="overlay"
        position="end"
        [width]="350"
        (keyup.enter)="searchFilter.emit(); toggleDrawer()">
        <ng-template kendoDrawerTemplate>
            <div class="filterHeader p-3">
                <fa-icon
                    class="pull-left bounce"
                    title="{{ 'Close' | translate }}"
                    size="2x"
                    [icon]="['far', 'caret-square-right']"
                    (click)="toggleDrawer()"></fa-icon>
                <h2>
                    <fa-icon [icon]="['fas', 'filter']"></fa-icon>
                    {{ 'Filters' | translate }}
                </h2>
            </div>
            <ng-content></ng-content>
            @if (showFilterButtons) {
                <div class="row mb-2">
                    <div class="col">
                        <div class="float-right" kendoTooltip>
                            <button
                                class="btn btn-sm btn-primary mr-2"
                                title="{{ 'Search' | translate }}"
                                (click)="searchFilter.emit(); toggleDrawer()">
                                <fa-icon [icon]="['fas', 'search']"></fa-icon>
                            </button>
                            <button
                                class="btn btn-sm btn-secondary mr-3"
                                title="{{ 'Clear' | translate }}"
                                (click)="clearFilter.emit()">
                                <fa-icon [icon]="['fas', 'times']"></fa-icon>
                            </button>
                        </div>
                    </div>
                </div>
            }
        </ng-template>
    </kendo-drawer>
    @if (showToggleButton) {
        <kendo-drawer-content>
            <button class="k-button toggleButton" (click)="toggleDrawer()">
                <fa-icon [icon]="['fas', 'filter']"></fa-icon>
            </button>
        </kendo-drawer-content>
    }
</kendo-drawer-container>
